module.exports = "/_next/static/images/071971e08de04ef9550dd7f7646565d8-boy-looking-to-the-front@1x.jpg";